import bairro from './bairro'
import cliente from './cliente'
import empresa from './empresa'
import estado from './estado'
import funcionalidade from './funcionalidade'
import logradouro from './logradouro'
import logradouroTipo from './logradouro-tipo'
import limiteMensagem from './limite-mensagem'
import modulo from './modulo'
import municipio from './municipio'
import notaVersao from './nota-versao'
import pais from './pais'
import ramoAtividade from './ramo-atividade'
import sistema from './sistema'
import usuario from './usuario'
import waba from './waba'
import wabaTemplate from './waba-template'

export default baseUrl => {
    baseUrl = `${baseUrl}/cadastro`

    return {
        bairro: bairro(baseUrl),
        cliente: cliente(baseUrl),
        empresa: empresa(baseUrl),
        estado: estado(baseUrl),
        funcionalidade: funcionalidade(baseUrl),
        logradouro: logradouro(baseUrl),
        logradouroTipo: logradouroTipo(baseUrl),
        limiteMensagem: limiteMensagem(baseUrl),
        modulo: modulo(baseUrl),
        municipio: municipio(baseUrl),
        notaVersao: notaVersao(baseUrl),
        pais: pais(baseUrl),
        ramoAtividade: ramoAtividade(baseUrl),
        sistema: sistema(baseUrl),
        usuario: usuario(baseUrl),
        waba: waba(baseUrl),
        wabaTemplate: wabaTemplate(baseUrl),
    }
}
